<template>
    <div class="subscription--inner subscription--loader">
        <div class="loader">
            <div />
            <div />
            <div />
        </div>
    </div>
</template>
<script>
export default {
    name: 'SubscriptionScreenLoader'
}
</script>
